import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

var cargadorCatalogosPanelRoles = null;
var cargadorRol = null;

const store = {
  state: {
    panelRol:{},
    panelRoles:{},
    panelRolHeader:{},
  },
  getters: {
    panelRol: state => {
      return state.panelRol;
    },
    panelRolHeader: state => {
      return state.panelRolHeader;
    },
    panelRoles: state => {
      return state.panelRoles;
    },
  },
  mutations: {
    ASIGNA_PANELROL(state, data) {
      state.panelRol= data;
    },
    ASIGNA_PANELROL_HEADER(state, data) {
      state.panelRolHeader= data;
    },
    ASIGNA_PANELROLES(state, data) {
      state.panelRoles= data;
    },
  },
  actions: {

    agregarPanelRol({ dispatch, getters }, panelRol) {
      return new Promise((resolve, reject) => {
        db.collection("Panel_Roles")
        .add(panelRol)
          resolve()
      })
    },

    actualizarPanelRol({ dispatch, getters }, panelRol) {
       return new Promise((resolve, reject) => {
        db.collection("Panel_Roles")
           .doc(panelRol.id)
           .update(panelRol)

           resolve()
       })
     },


    eliminarPanelRol({getters}, idRol) {
      return db.collection("Panel_Roles")
        .doc(idRol)
        .delete()
    },



    /**CARGAR ROL SELECCIONADO */
    cargarPanelRol({ commit,getters }, idRol) {
      console.log('Store panelRoles carga: ' + idRol)
      return new Promise((resolve, reject) => {
        let docPath = db.collection("Panel_Roles").doc(idRol);
        docPath.onSnapshot(doc => {
          commit('ASIGNA_PANELROL', doc.data())
          resolve(doc.data())
        })
      })
    },

    cargarPanelRolHeader({ commit,getters }, idRol) {
      return new Promise((resolve, reject) => {
        if (cargadorRol === null) {
          let docPath = db.collection("Panel_Roles").doc(idRol);
          cargadorRol = docPath.onSnapshot(doc => {
            commit('ASIGNA_PANELROL_HEADER', doc.data())
            resolve(doc.data())
          })
        } else {
          resolve()
        }
      })
    },


    /** Cargar lista de panelRoles para la tabla */
    cargaIndicePanelRoles({ commit, getters }) {
      return new Promise((resolve, reject) => {
        if (cargadorCatalogosPanelRoles === null) {
          let docPath = db
            .collection(FS_COLLECTIONS.PIXAN)
            .doc('Panel_Roles')
          cargadorCatalogosPanelRoles = docPath.onSnapshot(doc => {
            resolve()
            commit('ASIGNA_PANELROLES', doc.data())
          })
        } else {
          resolve()
        }
      })
    },
   
    

  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/panel_roles/panel_roles.js